import ViewAdminPromotion from '@/views/ViewAdminPromotion.vue'
import ViewLogisticCalculate from '@/views/ViewLogisticCalculate.vue'
import ViewLogisticProvince from '@/views/ViewLogisticProvince.vue'
import ViewLogisticReport from '@/views/ViewLogisticReport.vue'
import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import Layouts from '../views/Layouts.vue'

import Login from '../views/Login.vue'
import ViewAdminUser from '../views/ViewAdminUser.vue'
import ViewAdminData from '../views/ViewAdminData.vue'
import ViewAdminSetting from '../views/ViewAdminSetting.vue'
import ViewAdminCampaign from '../views/ViewAdminCampaign.vue'
import ViewLineStream from '../views/ViewLineStream.vue'
import ViewLogisticTruck from '../views/ViewLogisticTruck.vue'
import ViewLogisticRoute from '../views/ViewLogisticRoute.vue'
import ViewLogisticSetting from '../views/ViewLogisticSetting.vue'
import ViewCart from '../views/ViewCart.vue'
import ViewCustomer from '../views/ViewCustomer.vue'
import ViewHome from '../views/ViewHome.vue'
import ViewOrder from '../views/ViewOrder.vue'
import ViewShipping from '../views/ViewShipping.vue'
import ViewOrderPending from '../views/ViewOrderPending.vue'
import ViewOverview from '../views/ViewOverview.vue'
import ViewProduct from '../views/ViewProduct.vue'
import ViewPromotion from '../views/ViewPromotion.vue'
import ViewProfile from '../views/ViewProfile.vue'
import ViewReport from '../views/ViewReport.vue'
import ViewReportSaleSoFar from '../views/reports/ViewReportSaleSoFar.vue'
import ViewReportReceiptSoFar from '../views/reports/ViewReportReceiptSoFar.vue'
import ViewReportSlip from '../views/reports/ViewReportSlip.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/',
    name: 'layouts',
    redirect: 'overview',
    component: Layouts,
    children: [
      {
        path: '/home',
        name: 'Home',
        component: ViewHome,
      },
      {
        path: '/profile',
        name: 'Profile',
        component: ViewProfile,
      },
      {
        path: '/admin',
        name: 'Admin',
        component: ViewAdminUser,
      },
      {
        path: '/data',
        name: 'Data',
        component: ViewAdminData,
      },
      {
        path: '/admin_setting',
        name: 'Setting',
        component: ViewAdminSetting,
      },
      {
        path: '/campaigns',
        name: 'Campaign',
        component: ViewAdminCampaign,
      },
      {
        path: '/campaigns/:price_group',
        name: 'Campaign',
        component: ViewAdminCampaign,
      },
      {
        path: '/line_stream',
        name: 'LineStream',
        component: ViewLineStream,
      },
      {
        path: '/trucks',
        name: 'Truck',
        component: ViewLogisticTruck,
      },
      {
        path: '/routes',
        name: 'Routes',
        component: ViewLogisticRoute,
      },
      {
        path: '/provinces',
        name: 'Province',
        component: ViewLogisticProvince,
      },
      {
        path: '/logistic_cal',
        name: 'Calculate',
        component: ViewLogisticCalculate,
      },
      {
        path: '/logistic_report',
        name: 'Logistic Report',
        component: ViewLogisticReport,
      },
      {
        path: '/logistic_setting',
        name: 'Setting',
        component: ViewLogisticSetting,
      },
      {
        path: '/campaign/:id/promotions',
        name: 'Promotions',
        component: ViewAdminPromotion,
      },
      {
        path: '/overview',
        name: 'Overview',
        component: ViewOverview,
      },
      {
        path: '/customer',
        name: 'Customer',
        component: ViewCustomer,
      },
      {
        path: '/product',
        name: 'Product',
        component: ViewProduct,
      },
      {
        path: '/promotion',
        name: 'Promotion',
        component: ViewPromotion,
      },
      {
        path: '/order',
        name: 'Order',
        component: ViewOrder,
      },
      {
        path: '/order_pending',
        name: 'OrderPending',
        component: ViewOrderPending,
      },
      {
        path: '/shipping',
        name: 'Shipping',
        component: ViewShipping,
      },
      {
        path: '/order/status/:status/id/:id',
        name: 'Order',
        component: ViewOrder,
      },
      {
        path: '/order/status/:status/from/:from/to/:to',
        name: 'Order',
        component: ViewOrder,
      },
      {
        path: '/report',
        name: 'Report',
        component: ViewReport,
      },
      {
        path: '/report/sale_so_far',
        name: 'Report sale so far',
        component: ViewReportSaleSoFar,
      },
      {
        path: '/report/sale_so_far/month/:month',
        name: 'Report sale so far on month',
        component: ViewReportSaleSoFar,
      },
      {
        path: '/report/receipt_so_far',
        name: 'Report receipt so far',
        component: ViewReportReceiptSoFar,
      },
      {
        path: '/report/receipt_so_far/month/:month',
        name: 'Report receipt so far on month',
        component: ViewReportReceiptSoFar,
      },
      {
        path: '/report/slip',
        name: 'Report slip',
        component: ViewReportSlip,
      },
      {
        path: '/report/slip/month/:month',
        name: 'Report slip month',
        component: ViewReportSlip,
      },
      {
        path: '/cart',
        name: 'Cart',
        component: ViewCart,
      },
      {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/ViewAbout.vue'),
      },
    ],
  },


]

const router = new VueRouter({
  routes,
})

export default router
